<div class="send-itinerary-container">
  <button [class.primary-button-inactive]="itineraryButtonDisabled" class="primary-button send-button"
    [disabled]="itineraryButtonDisabled" (click)="openMessageModal()"
    >{{"send-itinerary-button" | translate}}</button>
</div>
